<script setup>
import SelectInput from '@/components/shared/form/SelectInput.vue'
import {useTimezones} from '@/composables/use-timezones.js'
import {onMounted} from 'vue'

//Emits and props
defineEmits([
  'input',
  'dirty',
])

//Get timezones
const {
  timezones,
  isLoadingTimezones,
  loadTimezones,
} = useTimezones()

//Load timezones
onMounted(loadTimezones)
</script>

<template>
  <SelectInput
    v-bind="$attrs"
    required
    is-filterable
    :is-loading="isLoadingTimezones"
    :placeholder="isLoadingTimezones ? 'Loading timezones...' : 'Select timezone'"
    aria-label="Select timezone"
    :options="timezones"
    @input="$emit('input', $event)"
    @dirty="$emit('dirty', $event)"
  />
</template>
